import React from 'react';
import { useTranslation } from 'react-i18next';
import { renderBlockSettings } from './blocks';
import { Panel } from './Panel';
import { resolveBlockSettingsExpandedSections } from './settingsPanelDefaults';
import { findBlock } from '../domain/find';
import { translateBlockLabel } from '../domain/labels';
import { selectDocument } from '../domain/selectors';
import { useEditorActions, useEditorStore } from '../domain/redux/hooks';
import type { Block } from '../domain/types';

type BlockSettingsPanelProps = {
  rowId: string;
  columnId: string;
  blockId: string;
};

export function BlockSettingsPanel({
  rowId,
  columnId,
  blockId,
}: BlockSettingsPanelProps) {
  const { t } = useTranslation();
  const document = useEditorStore(selectDocument);
  const { updateBlock } = useEditorActions();
  const block = findBlock(document, rowId, columnId, blockId);
  if (!block) {
    return null;
  }

  const patch = (next: Partial<Block>) =>
    updateBlock(rowId, columnId, blockId, next);

  return (
    <Panel
      key={blockId}
      title={t("{{block}} settings", { block: translateBlockLabel(t, block) })}
      defaultExpandedSectionIds={resolveBlockSettingsExpandedSections(
        document,
        rowId,
        block,
      )}
    >
      {renderBlockSettings({
        block,
        patch,
        textTheme: document.settings,
        rowId,
        columnId,
      })}
    </Panel>
  );
}
